var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import RcPagination, { PaginationLocale, } from 'rc-pagination';
import enUS from 'rc-pagination/lib/locale/en_US';
import classNames from 'classnames';
// import LeftOutlined from '@ant-design/icons/LeftOutlined';
// import RightOutlined from '@ant-design/icons/RightOutlined';
// import DoubleLeftOutlined from '@ant-design/icons/DoubleLeftOutlined';
// import DoubleRightOutlined from '@ant-design/icons/DoubleRightOutlined';
import TransferLeft from '../_util/bonreeIcons/TransferLeft';
import TransferRight from '../_util/bonreeIcons/TransferRight';
import FastTransferLeft from '../_util/bonreeIcons/FastTransferLeft';
import FastTransferRight from '../_util/bonreeIcons/FastTransferRight';
import Abbreviation from '../_util/bonreeIcons/Abbreviation';
import MiniSelect from './MiniSelect';
import Select from '../select';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import { ConfigContext } from '../config-provider';
import useBreakpoint from '../grid/hooks/useBreakpoint';
export { PaginationLocale };
const Pagination = (_a) => {
    var { prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className, size, locale: customLocale, selectComponentClass } = _a, restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale", "selectComponentClass"]);
    const { xs } = useBreakpoint();
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    const getIconsProps = () => {
        // const ellipsis = <span className={`${prefixCls}-item-ellipsis`}>•••</span>;
        const ellipsis = (<span className={`${prefixCls}-item-ellipsis`}>
        <Abbreviation />
      </span>);
        let prevIcon = (<button className={`${prefixCls}-item-link`} type="button" tabIndex={-1}>
        <TransferLeft />
      </button>);
        let nextIcon = (<button className={`${prefixCls}-item-link`} type="button" tabIndex={-1}>
        <TransferRight />
      </button>);
        let jumpPrevIcon = (<a className={`${prefixCls}-item-link`}>
        {/* You can use transition effects in the container :) */}
        <div className={`${prefixCls}-item-container`}>
          <FastTransferLeft className={`${prefixCls}-item-link-icon`}/>
          {ellipsis}
        </div>
      </a>);
        let jumpNextIcon = (<a className={`${prefixCls}-item-link`}>
        {/* You can use transition effects in the container :) */}
        <div className={`${prefixCls}-item-container`}>
          <FastTransferRight className={`${prefixCls}-item-link-icon`}/>
          {ellipsis}
        </div>
      </a>);
        // change arrows direction in right-to-left direction
        if (direction === 'rtl') {
            [prevIcon, nextIcon] = [nextIcon, prevIcon];
            [jumpPrevIcon, jumpNextIcon] = [jumpNextIcon, jumpPrevIcon];
        }
        return {
            prevIcon,
            nextIcon,
            jumpPrevIcon,
            jumpNextIcon,
        };
    };
    const renderPagination = (contextLocale, localeCode) => {
        const locale = Object.assign(Object.assign({}, contextLocale), customLocale);
        const isSmall = size === 'small' || !!(xs && !size && restProps.responsive);
        const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        const extendedClassName = classNames({
            mini: isSmall,
            [`${prefixCls}-rtl`]: direction === 'rtl',
        }, className);
        let { showTotal } = restProps;
        if (showTotal === undefined || (typeof showTotal === 'boolean' && showTotal === true)) {
            showTotal = total => (localeCode === 'zh-cn' ? `共有 ${total} 条` : `Total ${total}`);
        }
        else if (typeof showTotal === 'boolean' && showTotal === false) {
            showTotal = undefined;
        }
        if (localeCode === 'zh-cn') {
            locale.jump_to = '前往';
        }
        return (<RcPagination {...getIconsProps()} {...restProps} showTotal={showTotal} prefixCls={prefixCls} selectPrefixCls={selectPrefixCls} className={extendedClassName} selectComponentClass={selectComponentClass || (isSmall ? MiniSelect : Select)} locale={locale}/>);
    };
    return (<LocaleReceiver componentName="Pagination" defaultLocale={Object.assign(Object.assign({}, enUS), { page: 'page' })}>
      {renderPagination}
    </LocaleReceiver>);
};
export default Pagination;
